/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export var isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArrayLike.js.map 



//////////////////
// WEBPACK FOOTER
// C:/Workspace/customer-manager/node_modules/rxjs/_esm5/util/isArrayLike.js
// module id = ../../../../rxjs/_esm5/util/isArrayLike.js
// module chunks = vendor